import { defineStore } from 'pinia';
import type { CbtTestSession } from '@/types/composition-functions';

export const useCBTSessionStore = defineStore('cbtSession', {
  state: () => ({
    session: null as CbtTestSession | null,
  }),
  actions: {
    setSession(session: CbtTestSession) {
      this.session = session;
    },
    loadSession() {
      // Session is now managed via backend/memory only
    },
    clearSession() {
      this.session = null;
    },
  },
});
